import React from 'react';

const getPasswordStrength = (password) => {
  if (!password) return { strength: 0, label: '', color: '' };

  let score = 0;
  if (password?.length >= 6) score++;
  if (password?.length >= 10) score++;
  if (/[A-Z]/?.test(password) && /[a-z]/?.test(password)) score++;
  if (/[0-9]/?.test(password)) score++;
  if (/[^A-Za-z0-9]/?.test(password)) score++;

  if (score <= 2) return { strength: 33, label: 'Weak', color: 'bg-error' };
  if (score <= 3) return { strength: 66, label: 'Medium', color: 'bg-warning' };
  return { strength: 100, label: 'Strong', color: 'bg-success' };
};

const PasswordStrengthBar = ({ password }) => {
  const { strength, label, color } = getPasswordStrength(password);

  if (!password) return null;

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-muted-foreground">Password strength</span>
        <span className={`text-xs font-medium ${
          label === 'Weak' ? 'text-error' :
          label === 'Medium'? 'text-warning' : 'text-success'
        }`}>{label}</span>
      </div>
      <div className="h-1.5 bg-muted rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-300 ${color}`}
          style={{ width: `${strength}%` }}
        />
      </div>
    </div>
  );
};

export default PasswordStrengthBar;
